import { operateRequest } from '@/utils/axios';
import { useHostConfigStore } from '@/store/hostConfigStore';

// 飞书项目能力统一由 playback-server 代理（服务端持有凭证并带重试/缓存），前端不再直连飞书

/**
 * 研发人员搜索：输入关键字请求飞书成员
 * @returns data 为成员数组（含 nameCn / userKey）
 */
export const getFeishuMembers = (params: { keyword: string }) =>
  operateRequest.get('/playback-server/playback/issue/users', {
    params,
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });

/**
 * 获取问题提报工作项字段定义（负责组等下拉选项由此透传）
 * @returns data 为字段定义数组（含 fieldKey / options / fieldTypeKey）
 */
export const getField = () =>
  operateRequest.get('/playback-server/playback/issue/fields', {
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });
